/**
 * Context para que componentes inline dentro del chat (PronunciationBlock
 * con su mini-drill "Repetí") puedan pausar/reanudar el envío de audio al
 * backend sin prop-drilling desde AppShell.
 *
 * Diseño:
 *   - AppShell wrappea EnglishModeShell con un Provider que delega los
 *     callbacks a `voice.pauseCapture` / `voice.resumeCapture`.
 *   - Los componentes inline consumen el context y llaman a los callbacks
 *     alrededor de su captura local.
 *   - Si no hay Provider (renderizado fuera de la sesión), los callbacks
 *     son no-ops — el componente sigue funcionando, pero sin la pausa.
 */

import { createContext } from 'react';

export interface VoiceCaptureControl {
  /** Bloquea envío de PCM al WS de la sesión principal. */
  pauseCapture(): void;
  /** Reanuda envío de PCM. */
  resumeCapture(): void;
}

const NOOP: VoiceCaptureControl = {
  pauseCapture: () => undefined,
  resumeCapture: () => undefined,
};

export const VoiceCaptureContext = createContext<VoiceCaptureControl>(NOOP);
